export type LlmDiagnosisStarterQ = {
  starter_q_1: string | null;
  starter_q_2: string | null;
};

export type LlmTaskDetails = {
  // レイヤー2（サイドバー展開パネル用）
  conclusion: string;
  reason: string;
  efficacy?: string;
  actions: string[];
  // レイヤー3（詳細ビュー・モーダル用）
  background?: string;
  criteria?: string;
  cause?: string;
  detailed_steps?: string[];
  points_to_note?: string;
  verification_period?: string;
  auto_fix_behavior?: string;
  revert_condition?: string;
};

export type BudgetCampaignData = {
  resource_id: string;
  name: string;
  status: string;
  monthly_budget: string | number;
  current_daily_budget: string | number;
  spent_amount: string | number;
  progress_rate: string;
  forecast_amount: string | number;
  forecast_rate: string;
  diff_amount: string | number;
  remaining_days: number;
};

export type LlmDiagnosisFlag = "low" | "medium" | "high" | "failure" | null;

export enum DiagnosisSeverity {
  HIGH = 'high',
  MEDIUM = 'medium',
  LOW = 'low',
  FAILURE = 'failure',
}

export type LlmDiagnosisStatus = "open" | "monitoring" | "blocked" | null;

export type LlmDiagnosisItem = {
  label: string | null;
  period: string | null;
  period_value: number | null;
  flag: LlmDiagnosisFlag;
  starter_q: LlmDiagnosisStarterQ | null;
  diagnosis_generated_at?: string | null;
  updated_at?: string | null;
  // 以下、行動直結型UIのための拡張プロパティ（Optional）
  platform?: "Meta" | "Google" | "Yahoo" | string;
  impact_value?: string;
  time_required?: string;
  is_immediate?: boolean;
  status?: LlmDiagnosisStatus;
  task_details?: LlmTaskDetails;
};

export type LlmBudgetDiagnosisItem = {
  label: string;
  period: string;
  period_value: number;
  diagnosis_reason: string | null;
  diagnosis_json: BudgetCampaignData[];
  diagnosis_generated_at?: string | null;
  updated_at: string | null;
  status: string;
  flag: LlmDiagnosisFlag;
  // 以下、行動直結型UIのための拡張プロパティ（Optional）
  platform?: "Meta" | "Google" | "Yahoo" | string;
  impact_value?: string;
  time_required?: string;
  is_immediate?: boolean;
  task_details?: LlmTaskDetails;
};

export type DiagnosisId = string;

export type LlmDiagnosis = {
  "diag-google-unit-budget"?: LlmBudgetDiagnosisItem;
  "diag-meta-unit-budget"?: LlmBudgetDiagnosisItem;
  "diag-yahoo-unit-budget"?: LlmBudgetDiagnosisItem;
  "diag-cv"?: LlmDiagnosisItem;
  "diag-cvr"?: LlmDiagnosisItem;
  "diag-hourly"?: LlmDiagnosisItem;

  // DIAG-001 などの動的キー（モック/新API）にも対応
  [key: string]: LlmDiagnosisItem | LlmBudgetDiagnosisItem | null | undefined;
};
